<!--
  - HOPE U (CHENGDU) NETWORK TECHNOLOGY CO., LTD (HOPEYOO.COM)
  - Copyright (c) 2018- 2020 All Rights Reserved.
  -->

<template>
  <div>
    <commodity-list :code="data" v-if="!empty" />
    <empty-data :is-show="{ empty: true, stroll: true }" v-else />
  </div>
</template>

<script>


import '@/sass/attribute.scss';
import Vue from 'vue';
import { Toast } from 'vant';
import EmptyData from '../Commodity/CommodityEmpty';
import CommodityList from '../Countries/CommodityList';

Vue.use(Toast);

export default {
  props: {
    sortKey: {
      type: String,
      default: '',
    },
  },
  components: {
    EmptyData,
    CommodityList,
  },
  watch: {
    sortKey() {
      this.fetchCommodities();
    },
  },
  data() {
    return {
      data: [],
      empty: false,
    };
  },
  created() {
    this.fetchCommodities();
  },
  methods: {
    fetchCommodities() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      this.$http
        .get('/api/commodities/plate', {
          params: {
            plate_id: this.$route.params.hashid, // eslint-disable-line camelcase
            sort: this.sortKey,
          },
        })
        .then((response) => {
          this.$set(this.$data, 'data', response.data.data);
          this.$nextTick(() => {
            Toast.clear();
            this.empty = this.data.length === 0;
          });
        });
    },
  },
};
</script>
